import { Button, CircularProgress, createTheme, Menu, styled } from '@mui/material';
import { React, useEffect, useState } from 'react';
import { ButtonGroup, Modal, Offcanvas, ToggleButton } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import { useAuth } from 'react-oidc-context';
import SessionExpiredModal from '../../utils/SessionExpiredModal';
import TransparentButton from '../../utils/TransparentButton';
import TransparentButtonDark from '../../utils/TransparentButtonDark';

const TextButton = styled(Button)(({ theme }) => ({
  color: 'white',
  textTransform: 'none',
  padding: '0.5vw 0.75vw',
}));

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
});

export default ({ show, onClose, userId }) => {
  const auth = useAuth();

  const [
    firstName,
    setFirstName,
  ] = useState('');

  const [
    lastName,
    setLastName,
  ] = useState('');

  const [
    email,
    setEmail,
  ] = useState('');

  const [
    role,
    setRole,
  ] = useState('');

  const [
    isLoading,
    setIsLoading,
  ] = useState(false);

  const [
    sessionExpired,
    setSessionExpired,
  ] = useState(false);

  const [
    anchorEl,
    setAnchorEl,
  ] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  function saveRoleHandler(userId, newRole) {
    fetch(`${window.origin}/api/users/${userId}/role`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth.user?.access_token}`,
      },
      body: JSON.stringify({
        desiredRole: newRole,
      }),
    }).then((response) => {
      if (response.status === 403) {
        setSessionExpired(true);
        throw new Error('Session expired');
      }
      return response.json();
    }).catch((error) => {
      console.error('Failed to fetch workers:', error);
    });
    onClose();
  }

  function closeHandler() {
    onClose();
    setTimeout(() => {
      setFirstName('');
      setLastName('');
      setEmail('');
      setRole('');
    }, 200);
  }

  useEffect(() => {
    if (userId !== '') {
      setIsLoading(true);
      fetch(`${window.origin}/api/users/${userId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth.user?.access_token}`,
        },
      }).then((response) => {
        if (response.status === 403) {
          setSessionExpired(true);
          throw new Error('Session expired');
        }
        return response;
      }).then(resp => resp.json()).then((data) => {
        console.log(data);
        setFirstName(data.firstName);

        setLastName(data.lastName);

        setEmail(data.email);

        setRole(data.role);
        setIsLoading(false);
      }).catch((error) => {
        console.error(error);
      });
    }
  }, [userId]);

  return (
    <>
      <SessionExpiredModal show={sessionExpired} />

      <Modal
        show={show}
        onHide={closeHandler}
        dialogClassName="modal-50w"
        aria-labelledby="example-custom-modal-styling-title"
      >

        <Modal.Body style={{ padding: '2vw 3vw', paddingBottom: '0vw', textAlign: 'center', color: 'rgb(0, 15, 30, 0.7)' }}>

          <h4 style={{ textAlign: 'center', fontSize: '1.3vw', marginBottom: '2vw', fontWeight: '500' }}>
            {firstName}
            {' '}
            {lastName}
          </h4>

          {/* <p style={{margin: 0, marginBottom: '2.5vw', fontWeight: '300', fontSize: '0.8vw', padding: '0 2vw', color: 'rgb(0, 15, 30, 0.7)'}}>Please provide details of the user you want to invite.</p> */}

          <p style={{ fontSize: '0.8vw', textAlign: 'left', marginBottom: '1vw', marginLeft: '0.5vw', color: 'rgb(0, 15, 30, 0.7)' }}>Profile</p>
          <div style={{ margin: '0.5vw 0vw 2vw 0vw', backgroundColor: 'rgb(254, 254, 255, 0.5)', borderRadius: '1vw' }}>
            <div style={{ display: 'flex', flexDirection: 'row', padding: '1vw 1.2vw', borderTopLeftRadius: '1vw', borderTopRightRadius: '1vw', marginTop: '0', marginBottom: '0' }}>
              <div style={{ flex: 1, fontWeight: '500', fontSize: '0.8vw' }}>
                <p style={{ margin: 0, textAlign: 'left' }}>First Name</p>
              </div>
              <div style={{ flex: 1 }}>
                <p style={{ textAlign: 'right', color: 'rgb(0, 15, 30, 0.7)', margin: 0, fontSize: '0.8vw' }}>{firstName}</p>
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', padding: '1vw 1.2vw', borderRadius: '0', marginTop: '0', marginBottom: '0' }}>
              <div style={{ flex: 1, fontWeight: '500', fontSize: '0.8vw' }}>
                <p style={{ margin: 0, textAlign: 'left' }}>Last Name</p>
              </div>
              <div style={{ flex: 1 }}>
                <p style={{ textAlign: 'right', color: 'rgb(0, 15, 30, 0.7)', margin: 0, fontSize: '0.8vw' }}>{lastName}</p>
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', padding: '1vw 1.2vw', borderBottomLeftRadius: '1vw', borderBottomRightRadius: '1vw', marginTop: '0', marginBottom: '0' }}>
              <div style={{ flex: 1, fontWeight: '500', fontSize: '0.8vw' }}>
                <p style={{ margin: 0, textAlign: 'left' }}>Email</p>
              </div>
              <div style={{ flex: 1 }}>
                <p style={{ textAlign: 'right', color: 'rgb(0, 15, 30, 0.7)', margin: 0, fontSize: '0.8vw' }}>{email}</p>
              </div>
            </div>
          </div>
          <Form.Group style={{ marginBottom: '1.5vw', flex: 1, textAlign: 'left' }}>
            <p style={{ fontSize: '0.8vw', textAlign: 'left', marginBottom: '1vw', marginLeft: '0.5vw', color: 'rgb(0, 15, 30, 0.7)' }}>Role Type</p>
            <p style={{ fontSize: '0.75vw', textAlign: 'left', marginBottom: '1vw', marginLeft: '0.5vw', color: 'rgb(0, 15, 30, 0.6)' }}>User role will determine what access they have</p>

            <div style={{ display: 'inline-block', backgroundColor: 'rgb(255, 255, 255, 0.6)', borderRadius: '0.6vw', padding: '0.3vw' }}>
              {[
                'Admin',
                'User',
              ].map((roleType, index) => (
                <span style={{}}>
                  <TransparentButtonDark
                    style={{ fontSize: '0.75vw', padding: '0.3vw 0.75vw', borderRadius: '0.5vw' }}
                    onClick={() => {
                      setRole(roleType);
                    }}
                    selected={role == roleType}
                  >
                    {roleType}
                  </TransparentButtonDark>
                </span>
              ))}
            </div>

          </Form.Group>

          {/* <Form.Group style={{marginBottom: '1vw', flex: 1, textAlign: 'left'}}>
                            <p style={{fontSize: '0.8vw', textAlign: 'left', marginBottom: '1vw', marginLeft: '0.5vw', color: 'rgb(0, 15, 30, 0.7)'}}>Delete User</p>
                            <p style={{fontSize: '0.75vw', textAlign: 'left', marginBottom: '1vw', marginLeft: '0.5vw', color: 'rgb(0, 15, 30, 0.6)'}}>This user will be unassigned from your organization</p>

                            <Button
                                id="basic-button"
                                aria-controls={open ? 'basic-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={open ? 'true' : undefined}
                                onClick={handleClick}
                                style={{marginLeft: '0.3vw',
                                    borderColor: 'rgb(255, 255, 255, 1)', color: 'rgb(255, 255, 255, 0.9)', padding: '0.3vw 0.8vw', marginBottom: '0.2vw', border: 'none', backgroundColor: 'rgb(181, 54, 54)', borderRadius: '0.4vw', textTransform: 'none', fontSize: '0.8vw', fontWeight: 500, letterSpacing: '0.03vw'
                                , marginTop: '0vw'}}
                                variant="contained"
                                tabIndex={-1}
                                >
                                Delete
                            </Button>
                            <Menu
                                id="basic-menu"
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleClose}
                                slotProps={{
                                list: {
                                    'aria-labelledby': 'basic-button',
                                },
                                }}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'left',
                                }}
                                transformOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }}
                            >
                                <div style={{margin: '0.5vw 1vw', textAlign: 'left'}}>
                                    <p style={{fontSize: '1vw', fontWeight: '500'}}>Confirmation</p>
                                    <p style={{fontSize: '0.8vw', fontWeight: '500'}}>Are you sure you want to delete this user?</p>
                                    <div style={{textAlign: 'right'}}>
                                        <Button>Cancel</Button>
                                        <Button variant="outlined" style={{
                                    borderColor: 'rgb(255, 255, 255, 1)', color: 'rgb(255, 255, 255, 0.9)', padding: '0.2vw 0.5vw', marginBottom: '0.2vw', border: 'none', backgroundColor: 'rgb(181, 54, 54)', borderRadius: '0.4vw', textTransform: 'none', fontSize: '0.7vw', fontWeight: 500, letterSpacing: '0.03vw'}}>Confirm</Button>
                                    </div>
                                </div>

                            </Menu>

                        </Form.Group> */}

          <Button
            onClick={() => saveRoleHandler(userId, role)}
            variant="outlined"
            style={{
              borderColor: 'rgb(255, 255, 255, 1)', color: 'rgb(255, 255, 255, 0.9)', padding: '0.7vw', marginBottom: '2.5vw', border: 'none', backgroundImage: 'linear-gradient(rgb(255, 255, 255, 0.05), rgb(10, 10, 10, 0.05)),linear-gradient(#1c6c6c, #1c6c6c)', borderRadius: '0.5vw', textTransform: 'none', fontSize: '1vw', fontWeight: 500, letterSpacing: '0.08vw',
              width: '100%', marginTop: '2vw' }}
          >
            Save
          </Button>

        </Modal.Body>
      </Modal>
      {/* <Offcanvas show={show} onHide={closeHandler} placement="end" style={{width: '23vw', backgroundColor: 'rgb(32, 30, 34, 0.7)', backdropFilter: 'blur(50px)', '-webkit-backdrop-filter': 'blur(50px)',border: '1px solid rgb(0, 15, 30, 0.2)', paddingLeft: '1vw', paddingRight: '1vw', paddingTop: '1vw', color: 'white', display: 'flex', flexDirection: 'column', margin: '1rem', borderRadius: '2vw'}}>
                <div style={{flex: 1}}>
                    <Offcanvas.Header  style={{padding: '1vw'}}>
                    <Offcanvas.Title style={{fontSize: '1.3vw'}}>{firstName} {lastName}</Offcanvas.Title>
                    </Offcanvas.Header>
                    { !isLoading && <Offcanvas.Body style={{paddingTop: '2vw', height: '100%'}}>
                        <Form.Group style={{marginBottom: '2vw', flex: 1, textAlign: 'left'}}>
                            <p style={{fontSize: '0.9vw', marginBottom: '1vw'}}>First Name</p>
                            <Form.Control style={{height: '2vw', backgroundColor: 'rgba(255,255,255,.05)', border: '1px solid rgb(0, 15, 30, 0.15)', borderRadius: '0.5vw', fontSize: '0.8vw', paddingLeft: '0.8vw'}} type="email" placeholder="First Name" value={firstName} disabled/>
                        </Form.Group>
                        <Form.Group style={{marginBottom: '2vw', flex: 1, textAlign: 'left'}}>
                            <p style={{fontSize: '0.9vw', marginBottom: '1vw'}}>Last Name</p>
                            <Form.Control style={{height: '2vw', backgroundColor: 'rgba(255,255,255,.05)', border: '1px solid rgb(0, 15, 30, 0.15)', borderRadius: '0.5vw', fontSize: '0.8vw', paddingLeft: '0.8vw'}} type="email" placeholder="Last Name" value={lastName} disabled/>
                        </Form.Group>
                        <Form.Group style={{marginBottom: '2vw', flex: 1, textAlign: 'left'}}>
                            <p style={{fontSize: '0.9vw', marginBottom: '1vw'}}>Email Address</p>
                            <Form.Control style={{height: '2vw', backgroundColor: 'rgba(255,255,255,.05)', border: '1px solid rgb(0, 15, 30, 0.15)', borderRadius: '.5vw', fontSize: '0.8vw', paddingLeft: '0.8vw'}} type="email" placeholder="Email Address" value={email} disabled/>
                        </Form.Group>
                        <Form.Group style={{marginBottom: '3vw', flex: 1, textAlign: 'left'}}>
                            <p style={{fontSize: '0.9vw', marginBottom: '1vw'}}>Role</p>
                            <p style={{fontSize: '0.75vw', color: 'rgb(0, 15, 30, 0.6)'}}>The role selected corresponds to the level of access this user has in Gayatri.</p>

                            <div class="dropdown">

                                <ButtonGroup className="btn-group-toggle" style={{}}>
                                    <ToggleButton
                                        key={1}
                                        id={`radio-1`}
                                        type="radio"
                                        variant='outline-light'
                                        name="radio"
                                        value='ED'
                                        onChange={() => setRole('Admin')}
                                        style={{
                                            borderTopLeftRadius: '0.2vw',
                                            borderBottomLeftRadius: '0.2vw',
                                            fontSize: '0.8vw',
                                            padding: '0.3vw 0.75vw',
                                            backgroundColor: role == 'Admin' ? 'white' : '',
                                            borderColor: role == 'Admin' ? 'white' : '',
                                            color: role == 'Admin' ? 'black' : '', // Text color for active button
                                        }}
                                    >
                                        Admin
                                    </ToggleButton>
                                    <ToggleButton
                                        key={2}
                                        id={`radio-2`}
                                        type="radio"
                                        variant='outline-light'
                                        name="radio"
                                        value='FY'
                                        onChange={() => setRole('User')}
                                        style={{
                                            borderTopRightRadius: '0.2vw',
                                            borderBottomRightRadius: '0.2vw',
                                            fontSize: '0.8vw',
                                            padding: '0.3vw 0.75vw',
                                            backgroundColor: role == 'User' ? 'white' : '',
                                            borderColor: role == 'User' ? 'white' : '',
                                            color: role == 'User' ? 'black' : '', // Text color for active button
                                        }}
                                    >
                                        User
                                    </ToggleButton>
                                </ButtonGroup>
                            </div>
                        </Form.Group>

                    </Offcanvas.Body>}
                    { isLoading && <>
                        <div style={{textAlign: 'center', paddingTop: '35vh'}}>
                            <CircularProgress color="inherit" />
                        </div>
                    </>}
                </div>
                <div style={{textAlign: 'right', paddingBottom: '1.5vw', paddingRight: '1vw'}}>

                    <TextButton variant='outlined' style={{ fontSize: '0.9vw', color: 'white', fontWeight: '500', padding: '0.25vw 1.5vw', marginRight: '1.25vw', borderRadius: '1.5vw', textDecoration: 'none' , borderColor: 'rgb(0, 15, 30, 0.15)', backgroundColor: 'rgb(254, 254, 255, 0.1)'}}  onClick={closeHandler}>
                        Close
                    </TextButton>
                    <Button variant='contained' style={{ fontSize: '0.9vw', color: 'white', fontWeight: '500', cursor: 'pointer', padding: '0.25vw 1.5vw', borderRadius: '1.5vw', backgroundColor: '#f25252', borderColor: '#f25252', textTransform: 'none'}}  onClick={() => saveRoleHandler(userId, role)}>
                        Save
                    </Button>
                </div>

            </Offcanvas> */}

    </>

  );
};
